import React, { useEffect } from 'react';

// Update the mobile tabs to include the spinner tab and ensure it shows the active state properly
const DashboardTabs = ({ activeTab, setActiveTab }) => {
  // Ensure tournaments tab is shown by default when component mounts
  useEffect(() => {
    // Only set default tab if no tab is selected or if it's not "tournaments"
    if (!activeTab || activeTab !== "tournaments") {
      setActiveTab("tournaments");
    }
  }, []);  // Empty dependency array ensures this runs only once on mount
  
  return (
    <div className="flex overflow-x-auto bg-white border-b mb-4">
      <button
        className={`flex-grow px-3 py-3 text-xs font-medium text-center whitespace-nowrap ${
          activeTab === "tournaments" ? "border-b-2 border-primary-600 text-primary-600" : "text-gray-600"
        }`}
        onClick={() => setActiveTab("tournaments")}
      >
        <div className="flex flex-col items-center justify-center">
          <svg className="w-5 h-5 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
          </svg>
          Tournaments
        </div>
      </button>

      <button
        className={`flex-grow px-3 py-3 text-xs font-medium text-center whitespace-nowrap ${
          activeTab === "profile" ? "border-b-2 border-primary-600 text-primary-600" : "text-gray-600"
        }`}
        onClick={() => setActiveTab("profile")}
      >
        <div className="flex flex-col items-center justify-center">
          <svg className="w-5 h-5 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          Profile
        </div>
      </button>

      <button
        className={`flex-grow px-3 py-3 text-xs font-medium text-center whitespace-nowrap ${
          activeTab === "spinner" ? "border-b-2 border-primary-600 text-primary-600" : "text-gray-600 text-yellow-500"
        }`}
        onClick={() => setActiveTab("spinner")}
      >
        <div className="flex flex-col items-center justify-center">
          <svg className="w-5 h-5 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Coin Spinner
        </div>
      </button>

      <button
        className={`flex-grow px-3 py-3 text-xs font-medium text-center whitespace-nowrap ${
          activeTab === "teams" ? "border-b-2 border-primary-600 text-primary-600" : "text-gray-600"
        }`}
        onClick={() => setActiveTab("teams")}
      >
        <div className="flex flex-col items-center justify-center">
          <svg className="w-5 h-5 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          Teams
        </div>
      </button>
      
      <button
        className={`flex-grow px-3 py-3 text-xs font-medium text-center whitespace-nowrap ${
          activeTab === "wallet" ? "border-b-2 border-primary-600 text-primary-600" : "text-gray-600 text-green-500"
        }`}
        onClick={() => setActiveTab("wallet")}
      >
        <div className="flex flex-col items-center justify-center">
          <svg className="w-5 h-5 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          Wallet
        </div>
      </button>
    </div>
  );
};

export default DashboardTabs;
